const UnexpectedError = () => {
    throw new Error("Unexpected Error!");
};

export default UnexpectedError;